import React, {  useRef  } from "react";
import Header from "../index/Header";
import Footer from "../index/Footer";


export default function PoliticaPrivacidad() {
    const scrollRef = useRef();
  return (
    
    <div className="relative font-cinzel text-eryndra-cream bg-eryndra-forest bg-cover bg-center min-h-screen overflow-hidden py-10">


      <Header scrollRef={scrollRef} backgroundColor="bg-eryndra-forest/20" />
<section class="max-w-4xl mx-auto p-6 text-eryndra-cream">
  <h1 class="text-4xl font-cinzel text-eryndra-gold mb-4">Política de Privacidad</h1>

  <p class="mb-4 font-bellefair text-xl">En cumplimiento con el Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018 (LOPDGDD), se informa a las personas usuarias de esta web:</p>

  <h2 class="text-2xl font-bold text-eryndra-gold mb-2">Responsable del tratamiento</h2>
  <p class="mb-4 font-bellefair text-xl">
    <strong>Titular:</strong> Eryndra Eventos<br />
    <strong>Correo electrónico:</strong> info@eryndraeventos.es
  </p>

  <h2 class="text-2xl font-bold text-eryndra-gold mb-2">Finalidad del tratamiento</h2>
  <ul class="list-disc list-inside mb-4 font-bellefair text-xl">
    <li>Responder a consultas y solicitudes de contacto.</li>
    <li>Enviar comunicaciones relacionadas con los servicios ofrecidos.</li>
    <li>Remitir newsletter si se ha dado consentimiento explícito.</li>
  </ul>

  <h2 class="text-2xl font-bold text-eryndra-gold mb-2">Legitimación</h2>
  <p class="mb-4 font-bellefair text-xl">La base legal para el tratamiento es el consentimiento del usuario al enviar sus datos a través de los formularios de esta web.</p>

  <h2 class="text-2xl font-bold text-eryndra-gold mb-2">Conservación</h2>
  <p class="mb-4 font-bellefair text-xl">Los datos se conservarán el tiempo necesario para cumplir con la finalidad para la que fueron recabados o hasta que se solicite su supresión.</p>

  <h2 class="text-2xl font-bold text-eryndra-gold mb-2">Destinatarios</h2>
  <p class="mb-4 font-bellefair text-xl">No se cederán datos a terceros salvo obligación legal o para la prestación del servicio contratado.</p>

  <h2 class="text-2xl font-bold text-eryndra-gold mb-2">Derechos</h2>
  <p class="mb-4 font-bellefair text-xl">Las personas usuarias pueden ejercer sus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad dirigiéndose a info@eryndraeventos.es. También pueden presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD).</p>

  <h2 class="text-2xl font-bold text-eryndra-gold mb-2">Seguridad</h2>
  <p class="mb-4 font-bellefair text-xl">Eryndra Eventos aplica medidas técnicas y organizativas adecuadas para garantizar la seguridad de los datos personales.</p>

  <h2 class="text-2xl font-bold text-eryndra-gold mb-2">Cambios en la política</h2>
  <p className="font-bellefair text-xl">Nos reservamos el derecho a modificar la presente política para adaptarla a novedades legislativas o jurisprudenciales.</p>
</section>
<Footer />
    </div>

  );
}